import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetCall, initialPage, Page } from "../api-model/api";
import { NotificationDto } from "../api-model/topbar/notifications";
import { AuthRequest } from "../config/serviceInstances";
import { Store } from "../store/store";

export const NotificationsState: GetCall<NotificationDto> = {
  loading: false,
  error: false,
  page: initialPage,
};

export const getNotifications = createAsyncThunk<
  Page<NotificationDto>,
  boolean | undefined
>(
  "/topbar/notifications/get",
  async (markAsRead = false) => {
    const params = markAsRead
      ? { markAsRead: true, readStatus: "ALL" }
      : { readStatus: "ALL" };
    const { data } = await AuthRequest.get<Page<NotificationDto>>(
      `/notifications`,
      { params }
    );

    return data;
  },
  {
    condition(_arg, { getState }) {
      const state = getState() as Store;
      return !state.notifications.loading;
    },
  }
);

// reducer
const notifications = createSlice({
  name: "topbar/notifications",
  initialState: NotificationsState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNotifications.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getNotifications.fulfilled, (state, action) => {
      state.loading = false;
      state.page = action.payload;
      state.error = false;
    });
    builder.addCase(getNotifications.rejected, (state) => {
      state.loading = false;
      state.error = true;
    });
  },
});

export default notifications;
